var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { devLog, nextTick } from '@ecom-zform/shared';
import { INTERNAL_LOG } from './constants';
export * from './checker';
export * from './constants';
var isDisabledLogRef = {
    value: false,
};
export var disableLog = function (val) {
    if (val === void 0) { val = true; }
    devLog('ZForm V2: disableLog', "disable log: " + val);
    isDisabledLogRef.value = val;
};
export var setStateLog = function (form, reason) {
    if (!form.root.__visibleReasonLog || isDisabledLogRef.value)
        return;
    devLog('setState', "path:" + form.address.string + " state changed, reason: " + (reason || '# please write a valid reason for better debug experience #'));
};
export var setExtraLog = function (form, reason) {
    if (!form.root.__visibleReasonLog || isDisabledLogRef.value)
        return;
    devLog('setExtra', "path:" + form.address.string + " extra changed, reason: " + (reason || '# please write a valid reason for better debug experience #'));
};
export var getState = function (fc, stateType) {
    if (stateType) {
        if (Array.isArray(stateType)) {
            var res_1 = {};
            stateType.forEach(function (type) {
                res_1[type] = fc[type].value;
            });
            Object.keys(stateType);
            return res_1;
        }
        else {
            return fc[stateType].value;
        }
    }
    return {
        value: fc.value.value,
        visible: fc.visible.value,
        label: fc.label.value,
        tooltip: fc.tooltip.value,
        placeholder: fc.placeholder.value,
        loading: fc.loading.value,
        rules: fc.rules.value,
        description: fc.description.value,
        error: fc.error.value,
        initialValue: fc.initialValue.value,
        disableValidate: fc.disableValidate.value,
        disabled: fc.disabled.value,
        initialized: fc.initialized.value,
        validating: fc.validating.value,
        modified: fc.modified.value,
        required: fc.required.value,
        validateFirst: fc.validateFirst.value,
        decorator: fc.decorator.value,
    };
};
export var generatePathString = function (addressArr) { return addressArr.join('/'); };
export var internalLog = function (log, fc) {
    return (fc ? "path: " + fc.address.string : '') + " " + INTERNAL_LOG + " -> " + log;
};
export var buildLazyCallback = function (originCb) {
    var count = 0;
    return function (state) { return __awaiter(void 0, void 0, void 0, function () {
        var currentCount;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    currentCount = count++;
                    return [4 /*yield*/, nextTick()];
                case 1:
                    _a.sent();
                    if (currentCount === count - 1) {
                        count = 0;
                        originCb(state);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
};
export var triggerModified = function (f, log) {
    __spreadArray([f], __read(f.allParent)).forEach(function (f) {
        return f.setState({
            modified: true,
        }, internalLog(log || 'allParent will set modified -> true', f));
    });
};
